import axios from "axios";
import { getErrorMessageFromAws } from "./aws";
/**
 `getServiceError`receives a parameter of type 'error' and returns a text.
 *@param (Error) error - an Error object from a try-cath statement
 */

export const getServiceError = (error: unknown): string => {

  if (axios.isAxiosError(error)) {
    if (error.response?.status === 401) {
      return "sesión expirada";
    }

    //verify if errors comes from aws api gateway
    if (error.response?.data?.source === "aws-gateway") {
      const awsError = error.response?.data;
      return getErrorMessageFromAws(awsError.responseType);
    }

    const msg = error.response?.data.message;
    if (typeof msg === "string") {
      return msg;
    }

    if (error.code === "ERR_NETWORK") return "Error en la red";
  }

  return "Ocurrió un error con el servidor";
};

/**
 * Extracts error type from backend error response
 * @param error - Error object from a try-catch statement
 * @returns "warning" if error type is warning, "error" otherwise
 */
export const getServiceErrorType = (error: unknown): "error" | "warning" => {
  if (axios.isAxiosError(error)) {
    const errorData = error.response?.data;
    if (errorData && typeof errorData === "object" && "type" in errorData) {
      return errorData.type === "warning" ? "warning" : "error";
    }
  }
  return "error";
};

/**
 * Extracts the machine-readable error code from a backend error response
 * @param error - Error object from a try-catch statement
 * @returns The response's `error_code`, or an empty string when there is none
 */
export const getServiceErrorCode: (error: unknown) => string = (error) => {
  if (axios.isAxiosError(error)) {
    const errorCode: unknown = error.response?.data?.error_code;
    if (typeof errorCode === "string") {
      return errorCode;
    }
  }
  return "";
};
